// This file stores constant data used throughout the application.

// A predefined list of job titles for the employee creation form.
// Using a constant list like this ensures data consistency.
export const JOB_TITLES = [
    "Care Giver",
    "Senior Care Giver",
    "Registered Nurse",
    "Team Lead",
    "Field Supervisor",
    "Care Coordinator",
    "Physiotherapist",
    "Office Staff",
];